import React, { memo } from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operationsSelected: Operation[];
}

const MF_FLAG = 'web.fieldSelection.module-federation';
const MF_OVERRIDE_KEY = 'field-selection-web';

const MFFieldSelectionPlugin: React.FC<IProps> = React.lazy(() =>
  import('fieldSelectionWeb/FieldSelectionPlugin')
);
const S3FieldSelectionPlugin: React.FC<IProps> = React.lazy(() =>
  importFromS3('field-selection-web')
);

export const FieldSelectionPluginContainer = memo(
  ({ operationsSelected }: IProps) => {
    const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());

    const useModuleFederation =
      Boolean(featureFlags?.[MF_FLAG]) ||
      (typeof window !== 'undefined' && Boolean(window.sessionStorage.getItem(MF_OVERRIDE_KEY)));

    const FieldSelectionPlugin = useModuleFederation ? MFFieldSelectionPlugin : S3FieldSelectionPlugin;

    return <FieldSelectionPlugin operationsSelected={operationsSelected} />;
  }
);
